/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { Popover } from '@headlessui/react';
import { X } from 'phosphor-react';

export const CloseButton = () => {
  return (
    <Popover.Button
      style={{
        color: "#353535",
        backgroundColor: 'transparent',
        border: "none",
        cursor: "pointer",
      }}
      title="Fechar formulário de suporte"
    >
      <X weight="bold" size={16} />
    </Popover.Button>
  );
};
